import { render, staticRenderFns } from "./HistoryList.vue?vue&type=template&id=5636df45&"
import script from "./HistoryList.vue?vue&type=script&lang=js&"
export * from "./HistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HistoryList.vue"
export default component.exports